const localStorageReducer = (state, { type, payload }) => {
    const cloneState = { ...state };
    switch (type) {
        case 'addSingleFavourite':
            return {
                ...cloneState,
                favourites: [...cloneState.favourites, payload],
            };
        case 'removeSingleFavourite':
            // eslint-disable-next-line no-case-declarations
            const newFavState = cloneState.favourites.filter((obj) => obj.liveUrl !== payload);
            return {
                ...cloneState,
                favourites: [...newFavState],
            };
        case 'clearAllFavourites':
            return {
                ...cloneState,
                favourites: [],
            };
        case 'addSingleComparison':
            return {
                ...cloneState,
                comparisons: [...cloneState.comparisons, payload],
            };
        case 'removeSingleComparison':
            // eslint-disable-next-line no-case-declarations
            const newComparisonState = cloneState.comparisons.filter((obj) => obj.liveUrl !== payload);
            return {
                ...cloneState,
                comparisons: [...newComparisonState],
            };
        case 'clearAllComparisons':
            return {
                ...cloneState,
                comparisons: [],
            };
        default:
            return state;
    }
};

export default localStorageReducer;
